export default __webpack_public_path__ + "static/media/screen_zendesk_1.eab6ae55.png";